import React from 'react';
import { motion } from 'framer-motion';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Serviceimg4 from '../images/homepage/home6.png';
import Serviceimg5 from '../images/landing/hvac/image1.png';
import './BusinessCTA.css';

const BusinessCTA = () => {
  const navigate = useNavigate();

  return (
    <motion.div 
      className="homebuss"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <div className="grdnt-bussvbx" style={{
         backgroundImage: `url(${Serviceimg5})`,
          backgroundRepeat: 'no-repeat',
         backgroundPosition: 'top',
          backgroundSize: 'cover',
        overflow: 'hidden',
      }}>
        <motion.div 
          className="inr-bussbx"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            Ready to simplify your service business?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
          >
            Start your 14-day free trial—no credit card, no commitment. Just smarter service management from day one.
          </motion.p>
          <motion.div 
            className="btn-inline"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            viewport={{ once: true }}
          > 
            <motion.button 
              className="btn" 
              onClick={() => navigate('/free-trial')}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.98 }}
            >
              Start Free Trial <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle', fill: '#fff' }} />
            </motion.button>
          </motion.div>
        </motion.div>
        <motion.div 
          className="inr-bussbx imgbx"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <motion.img 
            src={Serviceimg4}
          />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default BusinessCTA;
